import FuelRecords from './containers/FuelRecords';
import withRole from '../../hocs/withRole';

export default [{
  path: '/fuel',
  exact: true,
  component: withRole('*', FuelRecords),
}];
